module.exports = "https://web-assets.ifttt.com/packs/media/docs/feature-architecture-diagram-2d88032e.png";